import { takeLatest } from 'redux-saga/effects';
import fetchBankEntriesWorker from './bankEntriesWorkerSaga';
import { FETCH_BANK_ENTRIES_REQUEST } from '../../redux/modules/BankEntries/bankEntries-actions';

export default function* fetchBankEntriesWatcher() {
    yield takeLatest(FETCH_BANK_ENTRIES_REQUEST, fetchBankEntriesWorker);
}
